export class GlobalFilterParameterModel {
  tblGlobalFilterConfigurationId: number = null;
  clientId: number = null;
  userId: string = "";
  userRoles: string = "";
  selectedParentValue: string = "";
}
